import { toast } from "@redotech/redo-web/alert";
import { retry } from "@redotech/util/retry";

export async function saveWithRetry(
  save: () => Promise<unknown>,
): Promise<boolean> {
  try {
    await retry(save, 2, Temporal.Duration.from({ seconds: 2 }));
    return true;
  } catch {
    toast("Failed to save progress", { variant: "error" });
    return false;
  }
}
